<template>
  <v-card class="elevation-1 grey lighten-3 pa-2 comment-card">
    <v-row dense class="ma-0">
      <v-col cols="6" class="pa-1">
        <div class="label">Commentaires</div>
        <v-textarea
            dense
            solo
            flat
            hide-details
            :rows="5"
            auto-grow
            :readonly="readonly"
            @blur="editTexts"
            v-model="editedComment"
            class="textarea-compact"
        />
      </v-col>

      <v-col cols="6" class="">
        <div class="label">À prévoir</div>
        <v-textarea
            dense
            solo
            flat
            hide-details
            :rows="5"
            auto-grow
            :readonly="readonly"
            @blur="editTexts"
            v-model="editedTodoNote"
            class="textarea-compact"
        />
      </v-col>
    </v-row>

  </v-card>
</template>

<script>
import FormMixin from "@/components/mixins/FormMixin";
import {post} from "@/utils/api";

export default {
  name: "MeetTexts",
  components: {},
  emits:['texts-updated'],
  mixins: [FormMixin],
  props: {
    value: { type: Object, default: () => {} },
    readonly: { type: Boolean, default: false }
  },
  data: () => ({
    editedComment: "",
    editedTodoNote: "",
  }),
  watch: {
    value: {
      immediate: true,
      handler() {
        this.saveInitialTexts()
      }
    }
  },
  computed: {
    hasChanged() {
      return this.editedComment !== this.value.comment || this.editedTodoNote !== this.value.todoNote
    }
  },
  methods: {
    saveInitialTexts() {
      this.editedComment = this.value.comment
      this.editedTodoNote = this.value.todoNote
    },
    editTexts() {
      if (!this.hasChanged) { return }
      const url = `/api/workshop/${this.value.workshopId}/meet/${this.value.id}`

      const payload = {
        ...this.value,
        comment: this.editedComment,
        todoNote: this.editedTodoNote
      }

      post(url, payload).res(() => {
        this.$emit("texts-updated")
      })
    }
  }
}
</script>

<style scoped>

.comment-card {
  border-radius: 0 0 0 0;
}

.label {
  font-size: 12px;
  font-weight: 500;
  color: #616161; /* grey darken-2 */
  margin-bottom: 2px;
}

>>> .textarea-compact textarea  {
  font-size: 12px;
  line-height: 1.2;
  color: #616161;
  padding: 4px !important;
  max-height: 120px;
  overflow-y: auto !important;
}
</style>